var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"background-slider"},[_c('img',{staticClass:"main_body_img",attrs:{"src":_vm.images[Math.abs(_vm.currentNumber) % _vm.images.length],"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }